
import './App.css';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";  // podstrona Bootstrap Demo
import BootstrapDemo from "./BootstrapDemo/BootstrapDemo";
import Main from "./Main/Main";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
   
 
  return (
    <div id="container">
      
      <Router>
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
          <div className="container justify-content-center">
            <ul className="navbar-nav">
              <li className="nav-item mx-3">
                <Link className="nav-link" to="/">Main</Link>
              </li>
              <li className="nav-item mx-3">
                <Link className="nav-link" to="/BootstrapDemo">Bootstrap Demo</Link>
              </li>
            </ul>
          </div>
        </nav>

        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/BootstrapDemo" element={<BootstrapDemo />} />
          
        </Routes>
    </Router>
    </div>
  );
}

export default App;
